<template>
    <section class="max-w-6xl mx-auto px-4 py-12 text-gray-800">
      <h1 class="text-4xl font-bold mb-10 text-center">Our Products</h1>
      
      <p class="text-center mb-12 text-lg max-w-3xl mx-auto">
        We're building a new generation of air protection solutions — thoughtfully designed for real-life challenges in India.
        Our initial product lineup is under development and will soon be available to the public.
      </p>
  
      <div class="grid md:grid-cols-2 gap-8">
        <div class="p-6 border rounded-xl shadow-sm bg-white hover:shadow-md transition">
          <h2 class="text-2xl font-semibold mb-2">Invisible Nose Filters</h2>
        </div>
  
        <div class="p-6 border rounded-xl shadow-sm bg-white hover:shadow-md transition">
          <h2 class="text-2xl font-semibold mb-2">Smart Masks, and Tactical Grade Masks</h2>
        </div>
  
        <div class="p-6 border rounded-xl shadow-sm bg-white hover:shadow-md transition">
          <h2 class="text-2xl font-semibold mb-2">Indoor Air Purifiers</h2>
        </div>
  
        <div class="p-6 border rounded-xl shadow-sm bg-white hover:shadow-md transition">
          <h2 class="text-2xl font-semibold mb-2">Outdoor Air Purification Systems</h2>
        </div>
      </div>
  
      <div class="text-center mt-12">
        <p class="text-gray-600 italic">Product visuals and pre-order info coming soon.</p>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'ProductsComponent'
  }
  </script>
  
  <style scoped>
  </style>
  